"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartSlots = void 0;
const cheerio = __importStar(require("cheerio/slim"));
const htmlparser2 = __importStar(require("htmlparser2"));
const plugins_1 = require("../plugins");
const typeGuards_1 = require("../schema/typeGuards");
const constants_1 = require("../slotContainers/constants");
const lib_1 = require("../slotContainers/lib");
const slotContainers_1 = require("../slotContainers/slotContainers");
const ruleHandler_1 = require("./ruleHandler");
class SmartSlots {
    constructor(deps, config) {
        this.injectionCount = {};
        this.totalInjectionCount = ['A', 'B', 'C', 'D'].reduce((acc, next) => ({ ...acc, [next]: 0 }), {});
        this.slotIndexes = {};
        this.slotPlugin = {};
        this.slotInjectionConfigs = {};
        this.slotInjectionLimits = {};
        this.config = config;
        this.deps = deps;
        this.ruleHandler = new ruleHandler_1.RuleHandler({
            ruleSets: this.config.ruleSets,
            widgets: this.config.widgets,
            item: this.deps.contentItem,
            injectionType: this.deps.injectionType,
        });
        if (this.deps.contentStats) {
            this.contentStats = this.deps.contentStats;
            this.loadSlotInjectionLimits();
        }
        this.path = this.deps.path ?? this.deps.contentItem?.path ?? '';
        this.loadPlugins();
    }
    loadPlugins() {
        this.config.ruleSets.forEach(({ widgetType: plugin }) => {
            var _a, _b, _c, _d, _e, _f;
            if (plugin === 'Keystone') {
                (_a = this.slotPlugin)[plugin] ?? (_a[plugin] = new plugins_1.KeystonePlugin());
            }
            else if (plugin === 'InContentAd') {
                (_b = this.slotPlugin)[plugin] ?? (_b[plugin] = new plugins_1.InContentAdPlugin());
            }
            else if (plugin === 'Spot') {
                (_c = this.slotPlugin)[plugin] ?? (_c[plugin] = new plugins_1.SpotPlugin());
            }
            else if (plugin === 'FallbackVideo') {
                (_d = this.slotPlugin)[plugin] ?? (_d[plugin] = new plugins_1.FallbackVideoPlugin());
            }
            else if (plugin === 'Newsletters') {
                (_e = this.slotPlugin)[plugin] ?? (_e[plugin] = new plugins_1.NewslettersPlugin());
            }
            else if (plugin === 'Sellwild') {
                (_f = this.slotPlugin)[plugin] ?? (_f[plugin] = new plugins_1.SellwildPlugin());
            }
        });
    }
    loadSlotInjectionLimits() {
        constants_1.viewPorts.forEach((breakpoint) => {
            const contentSize = this.contentStats?.contentMeta().size[breakpoint];
            const config = (contentSize && this.config.densities[contentSize]) ??
                this.deps.legacyConfig?.detailInjection ??
                {};
            this.slotInjectionConfigs[breakpoint] = config;
            this.slotInjectionLimits[breakpoint] = {
                initial: {
                    characters: config?.minimumInitialCharacters?.[breakpoint] ??
                        constants_1.SLOT_INJECTION_LIMIT_DEFAULTS[breakpoint].initial,
                },
                subsequent: {
                    characters: config?.minimumSubsequentCharacters?.[breakpoint] ??
                        constants_1.SLOT_INJECTION_LIMIT_DEFAULTS[breakpoint].subsequent,
                },
                final: {
                    characters: config?.minimumFinalCharacters?.[breakpoint] ??
                        constants_1.SLOT_INJECTION_LIMIT_DEFAULTS[breakpoint].final,
                },
            };
        });
    }
    processMarkup(markup) {
        if (typeof markup !== 'string') {
            markup = this.deps.markup;
        }
        let $;
        if (this.deps.useHtmlParser2 ?? false) {
            const dom = htmlparser2.parseDocument(markup, { xmlMode: false });
            $ = cheerio.load(dom, null, false);
        }
        else {
            $ = cheerio.load(markup, null, false);
        }
        const { eligibleForFinalSlot = true, maxInjections = 0 } = this.config.settings;
        const opts = { hasEmbedCards: $('.m-embed-card').length > 0 };
        if (this.deps.enabled) {
            const injectionLimitReached = constants_1.viewPorts.reduce((acc, bp) => ({ ...acc, [bp]: false }), {});
            const smartSlotInjector = (breakpoint, injectionPointElement, markup) => {
                const slotNumber = lib_1.slotCounts[breakpoint];
                let result = '';
                if (maxInjections > 0 && this.totalInjectionCount[breakpoint] === maxInjections) {
                    injectionLimitReached[breakpoint] = true;
                }
                else {
                    const slotSettings = this.config.slots?.[slotNumber] ?? null;
                    if (slotSettings) {
                        // If configuration has provided a specific layout for a given slot, use it
                        // for populating the slot (this supports one or more variant names; rules are
                        // still evaluated for each specified variant).
                        slotSettings.widgets.forEach((widgetVariant) => {
                            const smartSlot = this.addSmartSlot(breakpoint, injectionPointElement, markup, {
                                variant: widgetVariant,
                            });
                            if (smartSlot.widget !== null) {
                                result += smartSlot.slot + '\n';
                            }
                        });
                    }
                    else {
                        // No specific layout given for this slot, so apply rules to determine the
                        // widget to render for this slot.
                        const smartSlot = this.addSmartSlot(breakpoint, injectionPointElement, markup);
                        if (smartSlot.widget !== null) {
                            result += smartSlot.slot + '\n';
                        }
                    }
                }
                return result;
            };
            constants_1.viewPorts.forEach((breakpoint) => {
                lib_1.slotCounts[breakpoint] = 0;
                (0, lib_1.resetSlotValues)(breakpoint);
            });
            this.resetTotalInjectionCount();
            const children = $.root().children().toArray();
            for (const element of children) {
                // If we reached the injection limit for every viewport, we
                // can stop looping.
                if (maxInjections > 0 && constants_1.viewPorts.every((b) => injectionLimitReached[b])) {
                    break;
                }
                (0, slotContainers_1.findInjectionPoints)($, this.deps, element, eligibleForFinalSlot, this.slotInjectionLimits, opts, markup, smartSlotInjector);
            }
        }
        const html = $.root().html();
        return html;
    }
    addSmartSlot(breakpoint, injectionPointElement, markup, options) {
        // 1. deps.contentSize must be present if contentStats is not provided;
        // but since both are optional, we will default to a 'medium' content size.
        const zone = 'smart-slot';
        const index = this.getCurrentSlotIndex(breakpoint, zone);
        const contentSize = this.contentStats?.contentMeta().size[breakpoint] ??
            this.deps.contentSizes?.[breakpoint] ??
            'medium'; // 1.
        // List of all possible widgets we could render according to rules.
        const widgets = this.ruleHandler.evaluateRules({
            index,
            contentSize,
            injectionPointElement,
            path: this.path,
            ...options,
        });
        // There are no widgets that pass rules
        if (widgets?.length === 0) {
            return { widget: null, slot: '' };
        }
        // Now we evaluate the widget configs
        for (const widget of widgets) {
            if (!constants_1.SUPPORTED_PLUGINS.includes(widget.widgetType) || !this.slotPlugin[widget.widgetType]) {
                console.error(`Unsupported smart-slot type: ${widget.widgetType}`);
                continue;
            }
            widget.config = {
                ...this.slotPlugin[widget.widgetType]?.defaultConfig,
                ...widget.config,
            };
            if ((0, lib_1.isDefined)(widget.config.isActive) && !widget.config.isActive) {
                continue;
            }
            if ((0, lib_1.isDefined)(widget.config.injectOn) &&
                !widget.config.injectOn.includes(breakpoint)) {
                continue;
            }
            if (!(0, lib_1.isDefined)(this.injectionCount[widget.name])) {
                this.injectionCount[widget.name] = 0;
            }
            if ((0, lib_1.isDefined)(widget.config.maxInjections) &&
                this.injectionCount[widget.name] >= widget.config.maxInjections) {
                continue;
            }
            if ((0, typeGuards_1.isFallbackVideoWidget)(widget) &&
                (0, lib_1.isDefined)(widget.config.videoRegex) &&
                widget.config.videoRegex.test(markup ?? '')) {
                continue;
            }
            // In the future we will have a priority system, now we will take the first one.
            this.contentStats?.slots[breakpoint].push({ index, type: widget.widgetType });
            this.injectionCount[widget.name]++;
            this.totalInjectionCount[breakpoint] += 1;
            this.getNextSlotIndex(breakpoint, zone); // Increments slot index.
            // Past this point we're asserting that all necessary plugins have been loaded.
            const contextConfig = {
                cssString: '',
                breakpoint,
            };
            if ((0, typeGuards_1.isKeystoneWidget)(widget)) {
                return {
                    slot: this.slotPlugin[widget.widgetType]?.render(widget.config, contextConfig) ?? '',
                    widget,
                };
            }
            if ((0, typeGuards_1.isSpotWidget)(widget)) {
                return {
                    slot: this.slotPlugin[widget.widgetType]?.render(widget.config, contextConfig) ?? '',
                    widget,
                };
            }
            if ((0, typeGuards_1.isInContentAdWidget)(widget)) {
                return {
                    slot: this.slotPlugin[widget.widgetType]?.render(widget.config, contextConfig) ?? '',
                    widget,
                };
            }
            if ((0, typeGuards_1.isFallbackVideoWidget)(widget)) {
                return {
                    slot: this.slotPlugin[widget.widgetType]?.render(widget.config, contextConfig) ?? '',
                    widget,
                };
            }
            if ((0, typeGuards_1.isNewslettersWidget)(widget)) {
                return {
                    slot: this.slotPlugin[widget.widgetType]?.render(widget.config, contextConfig) ?? '',
                    widget,
                };
            }
            if ((0, typeGuards_1.isSellwildWidget)(widget)) {
                return {
                    slot: this.slotPlugin[widget.widgetType]?.render(widget.config, contextConfig) ?? '',
                    widget,
                };
            }
        }
        return { widget: null, slot: '' };
    }
    initializeSlotIndex(breakpoint, zone) {
        if (this.slotIndexes[breakpoint] === undefined) {
            this.slotIndexes[breakpoint] = {};
        }
        if (!this.slotIndexes[breakpoint][zone]) {
            this.slotIndexes[breakpoint][zone] = 0;
        }
    }
    resetTotalInjectionCount() {
        this.totalInjectionCount = constants_1.viewPorts.reduce((acc, next) => ({ ...acc, [next]: 0 }), {});
    }
    getCurrentSlotIndex(breakpoint, zone) {
        this.initializeSlotIndex(breakpoint, zone);
        return this.slotIndexes[breakpoint][zone];
    }
    getNextSlotIndex(breakpoint, zone) {
        this.initializeSlotIndex(breakpoint, zone);
        return this.slotIndexes[breakpoint][zone]++;
    }
}
exports.SmartSlots = SmartSlots;
//# sourceMappingURL=smartSlots.js.map